export default __webpack_public_path__ + "media/icons/settings_gray-c5ecc1ba.svg";